import { FC } from "react";

import "./Spinner.css";

export interface SpinnerProps { }

export const Spinner: FC<SpinnerProps> = () => (
  <div className="spinner"><div></div><div></div><div></div><div></div></div>
)